export default __webpack_public_path__ + "static/media/calibri-bold.6f5f5aec.woff";